var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-products" },
        _vm._l(_vm.products, function(product) {
          return product.images && product.images.length > 0
            ? _c(
                "div",
                {
                  key: product.product_id,
                  staticClass: "product",
                  on: {
                    click: function($event) {
                      return _vm.handleOnClick(product)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "image" },
                    [
                      _c("img", {
                        attrs: {
                          alt: product.title,
                          src: product.images[0].value || ""
                        }
                      }),
                      _vm._v(" "),
                      _c("save-product", { attrs: { product: product } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "brand" }, [
                    _vm._v(_vm._s(product.brand))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(product.title))
                  ])
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          ref: "infiniteLoading",
          attrs: { spinner: "waveDots", "force-use-infinite-wrapper": "" },
          on: { infinite: _vm.performSearch }
        },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            staticClass: "no-more",
            attrs: { slot: "no-more" },
            slot: "no-more"
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            staticClass: "no-results",
            attrs: { slot: "no-results" },
            slot: "no-results"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.products.length,
              expression: "!products.length"
            }
          ],
          staticClass: "no-results"
        },
        [_vm._v("No search results found")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a270754", { render: render, staticRenderFns: staticRenderFns })
  }
}